export const mainmenuStyles = {
    mainmenu: {
        boxContainer: {
            bgcolor: "grey.50",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            ".MuiListItemIcon-root": {
                color: "grey.700",
            },
            ".MuiListItemText-primary": {
                color: "grey.800",
            },
            ".MuiListItemSecondaryAction-root": {
                color: "grey.700",
            },
            ".MuiListItemButton-root": {
                "&.Mui-selected": {
                    bgcolor: "grey.300",
                    ".MuiListItemIcon-root": {
                        color: "primary.900",
                    },
                    ".MuiListItemText-primary": {
                        color: "primary.900",
                        fontWeight: 500,
                    },
                    "&:hover": {
                        bgcolor: "grey.300",
                    },
                },
                "&:hover": {
                    bgcolor: "grey.200",
                    ".MuiListItemIcon-root": {
                        color: "primary.900",
                    },
                    ".MuiListItemText-primary": {
                        color: "primary.900",
                    },
                },
            },
        },
        appBar: {
            bgcolor: "primary.900",
            color: "common.white",
        },
        appBarBox: {
            flex: 1,
        },
        toolBar: {
            gap: 2,
            paddingTop: 2,
        },
        toolBarBox: {
            color: "primary.100",
            fontSize: "2rem",
        },
        titleBox: {
            textAlign: 'left',
        },
        title: {
            fontWeight: 'bold',
            lineHeight: 1.2,
        },
        subtitle: {
            opacity: 0.9,
            whiteSpace: "nowrap",
        },
    },
}
